import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { agentsData } from "Stores/agentsData";
import BotGlyph from "Pages/Dashboard/agents/BotGlyph";
import CopilotAgentCard, { liveCard } from "./CopilotAgentCard";

/**
 * The user's agents as cards. The block names which agents (ids from /v1/agents); the cards
 * themselves come from the live overview so a toggle or test run anywhere shows up here too.
 */
const AgentListBlock = observer(({ block }) => {
  const ids = (block.agents || []).map(r => r.id || (r.agent && r.agent.id)).filter(Boolean);
  useEffect(() => {
    agentsData.fetchOverview();
  }, []);
  if (!ids.length) return null;
  const loaded = Boolean(agentsData.overview);
  return (
    <div className="cpAgentCards">
      <div className="cpAgentCards__title">
        <BotGlyph size={16} />
        <span>Agents</span>
        <span className="cpAgentCards__count">{ids.length}</span>
      </div>
      <div className="cpAgentCards__grid">
        {ids.map(id => {
          const card = liveCard(id, null);
          return card ? (
            <CopilotAgentCard key={id} card={card} />
          ) : (
            <div key={id} className={`cpAgentCards__skel${loaded ? " is-missing" : " linear-background"}`} />
          );
        })}
      </div>
    </div>
  );
});

export default AgentListBlock;
